import axios from 'axios'
import api from '@/api'
import getCurrentUserId from '@/utils/get-current-user-id'

export const enumBounds = {
  kinds: ['appartment', 'house']
}

export default {
  add (data) {
    return api.post('/users/me/real_estates', { real_estate: data })
  },

  estimate (id) {
    return api.post(`/real_estates/${id}/estimate`)
  },

  estimateMan (id, options) {
    // Manual updates must always have this false
    options.estimateEnabled = false
    return api.post(`/real_estates/${id}/estimate`, options)
  },

  fetch () {
    return api.get(`/users/${getCurrentUserId()}/real_estates`)
  },

  fetchRealEstatesByUser (id) {
    return api.get(`/users/${id}/real_estates`)
  },

  fetchById (id) {
    return api.get(`/real_estates/${id}`)
  },

  fetchEstimate (id) {
    return api.get(`/real_estates/${id}/estimate`)
  },

  fetchHistory (id, from) {
    return api.get(`/real_estates/${id}/series/cash_values${from ? ('?from=' + from) : ''}`)
  },

  fetchCompleteHistory (id) {
    return api.get(`/real_estates/${id}/series/cash_values`)
  },

  update (id, data) {
    return api.put(`/real_estates/${id}`, data)
  },

  updateInfos (portfolioId, infos) {
    return api.put(`/portfolios/${portfolioId}/portfolio_infos`, {portfolio_infos: infos})
  },

  updateRealEstate (id, data) {
    return api.put(`/real_estates/${id}`, {real_estate: data})
  },

  delete (id) {
    return api.delete(`/real_estates/${id}`)
  },

  fetchAddress (query) {
    return axios.get('https://api-adresse.data.gouv.fr/search/', { params: {
      q: query
    }},
    {
      headers: {
        'Authorization': null,
        'Access-Control-Allow-Origin': '*'
      }
    })
  }
}
